import '../../styles/templates/pages/page.pro-program-apply.scss';
